import type { RegionCode } from 'google-libphonenumber';
import { LiliComboBoxWithInput } from '../LiliComboBoxWithInput';
import { ReactComponent as SearchIcon } from '../../../assets/shared/ic-shared-search.svg';
import { LiliError } from '../LiliError';
import { useLiliInternationalPhoneInputLogic } from './hooks/useLiliInternationalPhoneInputLogic';

interface LiliInternationalPhoneInputProps {
  id: string;
  inputValue: string;
  onInputValueChange: (val: string) => void;
  initialIsoCode?: RegionCode | null;
  onIsoCodeChange?: (isoCode: RegionCode) => void;
  onFieldValidationStatusChange?: (isValid: boolean) => void;
  isDisabled?: boolean;
  isSelectMenuDisabled?: boolean;
  errorMessage?: string;
  onBlur?: () => void;
  autoCompleteProperty?: string;
  filteredCountries?: RegionCode[];
  tabIndex?: number;
}

export const LiliInternationalPhoneInput = ({
  id,
  inputValue,
  onInputValueChange,
  isDisabled,
  isSelectMenuDisabled,
  errorMessage,
  initialIsoCode,
  onIsoCodeChange,
  onFieldValidationStatusChange,
  onBlur,
  autoCompleteProperty,
  filteredCountries,
  tabIndex,
}: LiliInternationalPhoneInputProps) => {
  const {
    countries,
    placeholder,
    selectedIsoCode,
    handleInputValueChange,
    localOnIsoCodeChange,
    handleFocus,
  } = useLiliInternationalPhoneInputLogic({
    inputValue,
    initialIsoCode,
    onIsoCodeChange,
    onInputValueChange,
    onFieldValidationStatusChange,
    filteredCountries,
  });

  return (
    <div className='w-full'>
      <LiliComboBoxWithInput
        onFocus={handleFocus}
        id={id}
        dataTestId={`${id}-international-phone-num`}
        items={countries}
        selectedComboBoxValue={selectedIsoCode}
        onItemSelected={localOnIsoCodeChange}
        onBlur={onBlur}
        inputValue={inputValue}
        onInputValueChange={handleInputValueChange}
        placeholder={placeholder}
        isSelectMenuDisabled={isSelectMenuDisabled}
        isDisabled={isDisabled}
        selectSearchPlaceholder='Search...'
        SelectSearchPrefixIcon={SearchIcon}
        autoCompleteProperty={autoCompleteProperty}
        tabIndex={tabIndex}
        isError={Boolean(errorMessage)}
      />

      <LiliError errorMessage={errorMessage} id={`${id}-error-container`} showIcon />
    </div>
  );
};
